<template>
  <Card no-padding class="bids-add-bulk-pricing">
    <header class="bids-add-bulk-pricing__header">
      <h2>
        {{ $t('ADVERTISEMENT.BULK_IMPORT.PRICING_TITLE') }}
      </h2>
      <p class="bids-add-bulk-pricing__header-desc">
        {{ $t('ADVERTISEMENT.BULK_IMPORT.PRICING_DESCRIPTION') }}
      </p>
    </header>
    <BidsAddBulkPricingTable />

    <div class="row align-middle bids-add-bulk-pricing__footer">
      <div
        v-show="isThereIncompleteBidInfo"
        class="text-alert column bids-add-bulk-pricing__warning"
      >
        <i class="el-icon-warning" />
        {{ $t('ADVERTISEMENT.BULK_IMPORT.PRICING_WARNING') }}
      </div>

      <div class="column bids-add-bulk-pricing__actions">
        <ElButton
          :disabled="isLoading"
          type="text"
          icon="el-icon-arrow-right"
          @click="cancel"
        >
          {{ $t('ADVERTISEMENT.BULK_IMPORT.PREV_STEP') }}
        </ElButton>
        <ElButton
          :disabled="isThereIncompleteBidInfo"
          :loading="isLoading"
          type="primary"
          @click="save"
        >
          {{ $t('SAVE') }}
        </ElButton>
      </div>
    </div>
  </Card>
</template>

<script>
import cloneDeep from 'lodash.clonedeep';
import Card from '@@/common/Card';
import BidsAddBulkPricingTable from './BidsAddBulkPricingTable';
import {
  BULK_IMPORT_LOAD_BIDS,
  BULK_IMPORT_BIDS,
  BULK_IMPORT_RESET,
} from '@/store/types';
import { mapActions, mapGetters } from 'vuex';
import createBidsObjectFromKeywords from './transformers/createBidsObjectFromKeywords';
import campaignId from '@/mixins/advertisement/campaignId';
import { BulkImport } from '@/api/api';

export default {
  name: 'BidsAddBulkPricing',
  components: {
    BidsAddBulkPricingTable,
    Card,
  },
  mixins: [campaignId],
  props: {
    keywords: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      bids: BULK_IMPORT_BIDS,
    }),
    isThereIncompleteBidInfo() {
      return Boolean(
        this.bids.find(
          ({ priceOffer, matchType }) => !priceOffer || !matchType,
        ),
      );
    },
  },
  mounted() {
    const clonedKeywords = cloneDeep(this.keywords);

    this.loadsBidsToStore(createBidsObjectFromKeywords(clonedKeywords));
  },
  methods: {
    ...mapActions({
      loadsBidsToStore: BULK_IMPORT_LOAD_BIDS,
      resetBulkImportStoreModule: BULK_IMPORT_RESET,
    }),
    cancel() {
      this.resetBulkImportStoreModule();

      this.$emit('cancel');
    },
    save() {
      this.isLoading = true;
      return BulkImport.addBulkBids({
        bids: this.bids,
        campaignId: this.campaignId,
      })
        .then(() => {
          this.resetBulkImportStoreModule();

          this.$emit('save');
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-pricing {
  &__footer {
    margin-top: $global-margin * 2;
  }

  &__warning {
    font-size: $lb-smaller-font-size;
  }

  &__actions {
    flex-grow: 0;
    flex-basis: auto;

    margin-left: auto;
    @include rtl() {
      margin-right: auto;
      margin-left: 0;
    }
  }

  &__header,
  &__footer {
    padding: $global-padding * 2;
  }

  &__header-desc {
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>
